import MarketPlace from '../components/marketplace/MarketPlace.vue';
import TransactionList from '../components/marketplace/Transactions';
import auth from '../middleware/auth';

export default [
    {
        name: 'MarketPlace',
        path: '/marketplace',
        component: MarketPlace,
        props: true,
        meta: {
            middleware: [auth],
            title: 'global.menu.marketplace'
        }
    },
    {
        name: 'TransactionList',
        path: '/marketplace/transaction/list',
        component: TransactionList,
        props: true,
        meta: {
            middleware: [auth],
            title: 'transactions.title'
        }
    }
];



// WEBPACK FOOTER //
// ./src/routes/marketplace.js